import { env } from '../env';

export const publicRuntimeConfig = {
  appName: 'meater' as const,
  auth: {
    url: env.NEXT_PUBLIC_AUTH_API_URL,
  },
  locally: {
    companyId: env.NEXT_PUBLIC_LOCALLY_COMPANY_ID,
    companyName: env.NEXT_PUBLIC_LOCALLY_COMPANY_NAME,
  },
  gtm: {
    id: env.NEXT_PUBLIC_GTM_ID,
  },
  bv: {
    environment: env.NEXT_PUBLIC_BV_ENVIRONMENT,
  },
  datagrail: {
    customerId: env.NEXT_PUBLIC_DATAGRAIL_CUSTOMER_ID,
    containerId: env.NEXT_PUBLIC_DATAGRAIL_CONTAINER_ID,
  },
  appEnv: env.NEXT_PUBLIC_APP_ENV,
  base: env.NEXT_PUBLIC_WEB_ENV,
  websiteUrl: env.NEXT_PUBLIC_WEBSITE_URL,
  assetDomain: env.NEXT_PUBLIC_ASSET_DOMAIN,
  contentTypeBasepath: env.NEXT_PUBLIC_CONTENT_TYPE_BASEPATH,
  amplienceEndpoint: env.NEXT_PUBLIC_AMPLIENCE_ENDPOINT,
  recipeThumbnail: env.NEXT_PUBLIC_RECIPE_THUMBNAIL,
  braze: {
    appId: env.NEXT_PUBLIC_BRAZE_APP_ID,
  },
  refersion: {
    publicKey: env.NEXT_PUBLIC_REFERSION_PUBLIC_KEY,
  },
  shopify: {
    storeDomain: env.NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN,
    storefrontToken: env.NEXT_PUBLIC_SHOPIFY_PUBLIC_STOREFRONT_TOKEN,
    caStoreDomain: env.NEXT_PUBLIC_SHOPIFY_CA_STORE_DOMAIN,
    caStorefrontToken: env.NEXT_PUBLIC_SHOPIFY_CA_PUBLIC_STOREFRONT_TOKEN,
    apiVersion: env.NEXT_PUBLIC_SHOPIFY_API_VERSION,
  },
  invalidDeliveryKeys: env.NEXT_PUBLIC_INVALID_DELIVERY_KEYS,
  revalidate: {
    pageTime: env.NEXT_PUBLIC_REVALIDATE_PAGE_TIME,
    layoutTime: env.NEXT_PUBLIC_REVALIDATE_LAYOUT_TIME,
    searchTime: env.NEXT_PUBLIC_REVALIDATE_SEARCH_TIME,
    shopifyTime: env.NEXT_PUBLIC_SHOPIFY_CACHE_REVALIDATE_SECONDS,
  },
};

export default publicRuntimeConfig;
